import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { useAppContextProvider } from "../../../contextapi";

function TreeNode(props) {
    const [expanded, setExpanded] = useState(false);
    const {setLineFocus} = useAppContextProvider();

    const toggleExpansion = (expanded) => {
        setExpanded(!expanded);
    };

    const lineFocus = (val) => {
        props.setActiveItemId(val);
        setLineFocus(val)
    }

        // Helper to determine if this is the last node in the top-level tocData
        const isLastTopLevel =
            Array.isArray(props.tocData) &&
            props.tocData[props.tocData.length - 1]?.linenumber === props.node.linenumber;

        return (
                <li>
                        {props.node.subsections?.length === 0 ? (
                            <div className={props.activeItemId === props.node.linenumber ? "active no-tree-parent" : "no-tree-parent"}>
                                <p title={props.node.title} onClick={() => lineFocus(props.node)}>
                                    <button
                                        onKeyDown={e => {
                                            if (
                                                e.key === 'Tab' &&
                                                !e.shiftKey &&
                                                isLastTopLevel
                                            ) {
                                                e.preventDefault();
                                                // Focus the History tab button by id
                                                const histBtn = document.getElementById('history-tab-btn');
                                                if (histBtn) histBtn.focus();
                                            }
                                        }}
                                    >
                                        {props.node.title}
                                    </button>
                                </p>
                            </div>
                        ) : (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <div className={props.activeItemId === props.node.linenumber ? "tree-parent active" : "tree-parent"}>
                                <Button onClick={() => toggleExpansion(expanded)} aria-label={expanded ? 'expand' : 'collapse'}>
                                    {expanded ? <FaChevronDown /> : <FaChevronRight />}
                                </Button>
                                <p title={props.node.title}>
                                    <button
                                        onClick={() => lineFocus(props.node)}
                                        // Only add tab logic if this is the last top-level node and not expanded
                                        onKeyDown={e => {
                                            if (
                                                e.key === 'Tab' &&
                                                !e.shiftKey &&
                                                isLastTopLevel &&
                                                !expanded
                                            ) {
                                                e.preventDefault();
                                                const histBtn = document.getElementById('history-tab-btn');
                                                if (histBtn) histBtn.focus();
                                            }
                                        }}
                                    >
                                        {props.node.title}
                                    </button>
                                </p>
                            </div>
                        )}

                        {expanded && (
                                <ul>
                                        {props.node.subsections.map((child, index) => (
                                                <TreeNode key={child.id}
                                                    node={child}
                                                    dispatchFoucs={setLineFocus}
                                                    activeItemId={props.activeItemId}
                                                    setActiveItemId={props.setActiveItemId}
                                                    tocData={props.tocData}
                                                />
                                        ))}
                                </ul>
                        )}
                </li>
        );
}

export default TreeNode;

